// Port of api/fuel/app/classes/insights/worth/publisher.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import Publisher from 'offline/model/publisher'

export default Segment.extend({
	name: 'publisher',
	types: [Constants.TYPE_USER],
	insight: false,
	default_: false,
	detail: ['publisher'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var id = parseInt(vars.id, 10)
		var games = []
		var raw = Util.queryFast(
			'SELECT g.game_id AS g, COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0) AS w,' +
			' c.collection_rating AS r, c.collection_plays AS p' +
			' FROM (collection c JOIN game g ON c.game_id = g.game_id)' +
			' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id, game_publisher p' +
			' WHERE p.game_id = c.game_id' +
			' AND p.publisher_id = ' + id +
			' AND p.game_publisher_primary = 1' +
			' AND c.user_id = ' + owner.get_id() +
			' AND c.collection_own = 1' +
			' AND g.game_worth_value > 0' +
			' AND p.game_version_id = c.game_version_id' +
			' AND g.game_type = ' + Constants.GAME_TYPE_BASE +
			' ORDER BY w DESC'
		)

		for (var i = 0; i < raw.length; i++) {
			var gameId = parseInt(raw[i].g, 10)
			this._references.games.push(gameId)
			games.push({
				id: gameId,
				worth: Math.round(parseFloat(raw[i].w) || 0)
			})
		}

		var publisher = Publisher.with_id(id)

		return {
			publisher: publisher ? publisher.get_name() : '',
			games: games
		}
	}
})
